import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { ExportViewProps, ExportViewRef } from "./models";
import SearchFilter, { Filters } from "../../../Common/SearchFilter/SearchFilter";
import { searchFilterToExportExcelFilter } from "../../../Common/SearchFilter/utils";
import useDidMountEffect from "../../../Common/UseDidMountEffect";
import { CodeHolder } from "../../../../model/CodeHolder";
import { ApiBackend } from "../../../../providers/apibackend";

type SearchFilterType = {
    codeHolderId?: string;
    fromDate?: string;
    toDate?: string;
};

interface ISearchFilter {
    codeHolderId?: string;
    fromDate?: string;
    toDate?: string;
}

const OrdersUsedCode = forwardRef<ExportViewRef, ExportViewProps>((props, ref) => {
    const [searchFilter, setSearchFilter] = useState(null as ISearchFilter);
    const [codeHolders, setCodeHolders] = useState(null as CodeHolder[]);

    useImperativeHandle(ref, () => ({
        isValid: () => {
            return !!searchFilter?.codeHolderId;
        }
    }));

    useEffect(() => {
        new ApiBackend().listCodes({}).then((res) => {
            setCodeHolders(res);
        });
    }, []);

    useDidMountEffect(() => {
        props.onChange(searchFilterToExportExcelFilter<ISearchFilter>(searchFilter));
    }, [searchFilter]);

    const render = () => {
        return (
            <SearchFilter<SearchFilterType>
                id={"export-ordersusedcode-filter"}
                filters={{
                    "codeHolderId": {
                        id: "filter-codeHolderId",
                        type: "GenericSelect",
                        label: "Kodhållare",
                        size: 12,
                        multiple: false,
                        autocomplete: true,
                        itemDefinition: {
                            items: codeHolders == null ? [] : codeHolders.map(x => { return { name: x.name, value: x.id } }),
                            itemValueType: "string"
                        }
                    },
                    "fromDate": {
                        id: "filter-fromDate",
                        type: "Date",
                        label: "Order skapad från (valfritt)",
                        size: 6,
                    },
                    "toDate": {
                        id: "filter-toDate",
                        type: "Date",
                        label: "Order skapad till (valfritt, inklusive)",
                        size: 6,
                    },
                }}
                persist={true}
                onInit={(filter: Filters<SearchFilterType>) => {
                    setSearchFilter(filter as unknown as ISearchFilter);
                }}
                onChange={(filter: Filters<SearchFilterType>) => {
                    setSearchFilter(filter as unknown as ISearchFilter);
                }}
            />
        );
    };

    return render();
});

export default OrdersUsedCode;
